import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';

class ShareBar extends React.Component{
	render(){

			return(<div className="share-bar-holder">
					<div className="share-bar-inner">
							<div className="share-bar-row">
								<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_AM">
									<Iconset.appleHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="http://w.universal-music.de/save/campaign?campaign_id=7">
									<Iconset.spotifyHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_IT">
									<Iconset.itunesHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="http://smarturl.it/Blossom_AMZ">
									<Iconset.amazonHolo />
								</a>
							</div>
					
							<div className="share-bar-row">
								<a className="share-bar-ico" target="_blank" href="https://www.snapchat.com/add/realmilkychance">
									<Iconset.snapchatHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="https://www.instagram.com/milkychance_official/">
									<Iconset.instagramHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="https://www.facebook.com/milkychancemusic">
									<Iconset.facebookClean />
								</a>
								<a className="share-bar-ico" target="_blank" href="https://twitter.com/milkychance">
									<Iconset.twitterClean />
								</a>
								<a className="share-bar-ico" target="_blank" href="https://www.youtube.com/user/MilkysMusic">
									<Iconset.youtubeHolo />
								</a>
								<a className="share-bar-ico" target="_blank" href="http://milkychancemusic.tumblr.com/">
									<Iconset.tumblrHolo />
								</a>
								
							</div>

					</div>
				</div>);
	}
}

export default ShareBar;


// WEBPACK FOOTER //
// ./src/scripts/share_bar.js